<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="加工单元类型"
      edit-title
      id-key="ProcessUnitTypeId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="序号">
              <el-input
                type="number"
                v-int
                v-model="data.Sn"
                style="width: 100px"
              ></el-input>
              <span class="t-tips">*值越小排得越前</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加工阶段" prop="ProcessStage">
              <el-select v-model="data.Stage" clearable>
                <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="加工单元类型" label-width="100px">
              <el-input v-model="data.ProcessUnitTypeName" style="width: 200px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
  },
  data() {
    return {
      api: require("@/api/production/teProcessUnitType").default,
      formApi: require("@/api/sy/formSetting").default,
      machiningStageApi: require("@/api/ba/machiningStage").default,
      data: {
        ProcessUnitTypeId: null,
        ProcessUnitTypeName: null,
        Stage: null,
        Sn: null,
      },
      showList: [],
      machiningStageList: [],
      rules: {
        TransportNo: [{ required: true, message: "请输入编号" }],
        Abstract: [{ required: true, message: "请输入描述" }],
        SerialNumber: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
      
      this.machiningStageApi.list({ Status: 1 }).then((res) => {
        this.machiningStageList = res.Data;
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.data.ProcessUnitTypeId = null
      this.api.getMaxSn().then((res) => {
        console.log("🚀 ~ this.api.getMaxSn ~ res:", res)
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {
      this.api.info(data.ProcessUnitTypeId).then((res) => {
        console.log("🚀 ~ this.api.info ~ res:", res)
      });
    },
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
